import { Navigate } from 'react-router-dom';
import { useBoundStore } from '@maxis/client-logic/store/useBoundStore';
import { getLocalStorageItem } from '@maxis/client-logic/utils/localStorageUtil';
import { LOCAL_STORAGE_KEYS } from '@maxis/client-logic/constants/enumerates';
import PropTypes from 'prop-types';

const ProtectedLayout = ({ children }) => {
    const userId = useBoundStore((state) => state.user.userId);
    const accessToken = getLocalStorageItem(LOCAL_STORAGE_KEYS.ACCESS_TOKEN);

    return userId || accessToken ? (
        <>{children}</>
    ) : (
        <Navigate to={import.meta.env.VITE_PUBLIC_URL + '/login'} />
    );
};

ProtectedLayout.propTypes = {
    children: PropTypes.node.isRequired,
};

export default ProtectedLayout;
